import { render, staticRenderFns } from "./MedicalHistoryMain.vue?vue&type=template&id=4dedc9b4&scoped=true&"
import script from "./MedicalHistoryMain.vue?vue&type=script&lang=js&"
export * from "./MedicalHistoryMain.vue?vue&type=script&lang=js&"
import style0 from "./MedicalHistoryMain.vue?vue&type=style&index=0&id=4dedc9b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedc9b4",
  null
  
)

export default component.exports